export default __webpack_public_path__ + "static/images/logo_black.4174650.png";